







/**
 * See https://developer.vimeo.com/player/sdk/basics for more details
 */
import {
	defineComponent,
	onMounted,
	watch,
} from '@vue/composition-api';
import Player from '@vimeo/player';
import { v4 } from 'uuid';

interface ProgressEvent {
	duration: number; // The length of the video in seconds
	percent: number; // The amount of the video that has played in comparison to the length of the video; multiply by 100 to obtain the percentage
	seconds: number; // The amount of the video, in seconds, that has played
}

export default defineComponent({
	props: {
		// This can be either a video ID, or a video URL
		videoId: {
			type: String,
			required: true,
		},
		autoplay: Boolean,
	},
	setup(props, ctx) {
		const id = `vimeo-player-${v4()}`;

		let player: Player;
		const initPlayer = async (videoId: string) => {
			player = new Player(id, {
				url: videoId,
				byline: false,
				autoplay: props.autoplay,
			});
			player.on('ended', (data: ProgressEvent) => {
				if (data.percent === 1) {
					ctx.emit('done');
				}
			});
		};
		watch(() => props.videoId, async (curr: string) => {
			if (!player) {
				return;
			}
			const currentPlayerId = await player.getVideoUrl();
			if (currentPlayerId !== curr) {
				player.loadVideo(curr);
			}
		}, { immediate: true });
		onMounted(() => initPlayer(props.videoId));
		return {
			id,
		};
	},
});
